import { Request } from 'api';
import { AxiosResponse } from 'axios';

type ReturnType = Promise<AxiosResponse>;

const userLogOut = (): ReturnType => {
    return Request.post(`/authentication/logout`);
};
export default userLogOut;
